import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";
import { useT } from "@/lib/i18n";
import { HOME } from "@/constants/testIds";

const Testimonials = ({ testimonials = [] }) => {
    const { lang } = useLang();
    const t = useT(lang);

    return (
        <section
            data-testid={HOME.testimonialsSection}
            className="relative py-28 md:py-36 overflow-hidden"
            style={{ background: "var(--bg-secondary)" }}
        >
            <div className="mx-auto max-w-[1500px] px-6 md:px-10">
                <div className="flex items-center gap-3 mb-4">
                    <span className="w-8 h-px" style={{ background: "var(--purple)" }} />
                    <span className="font-body text-[11px] uppercase tracking-[0.32em]" style={{ color: "var(--purple)" }}>
                        {t("testimonials.eyebrow")}
                    </span>
                </div>
                <h2 className="font-serif text-4xl md:text-6xl tracking-tight mb-16" style={{ color: "var(--ink-1)" }}>
                    {t("testimonials.title")}
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
                    {testimonials.map((q, i) => (
                        <motion.figure
                            key={q.id}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                            className={`relative p-8 md:p-10 rounded-[36px] ${i % 2 === 1 ? "md:mt-16" : ""}`}
                            style={{
                                background: i === 1 ? "#FFF6EE" : "#FAF8F5",
                                border: "1px solid rgba(46,16,37,0.08)",
                                boxShadow: "0 30px 60px -30px rgba(46,16,37,0.15)",
                            }}
                        >
                            <div className="font-serif italic text-6xl leading-none absolute top-4 left-6" style={{ color: "var(--pink)", opacity: 0.4 }}>
                                “
                            </div>
                            <blockquote className="font-serif text-2xl md:text-3xl leading-[1.15] tracking-tight relative z-10 pt-4" style={{ color: "var(--ink-1)" }}>
                                {lang === "es" ? q.quote_es : q.quote_en}
                            </blockquote>
                            <figcaption className="mt-8 flex items-center justify-between font-body text-[11px] uppercase tracking-[0.28em]" style={{ color: "var(--ink-mute)" }}>
                                <span style={{ color: "var(--ink-1)" }}>— {q.author}</span>
                                <span>{q.occasion}</span>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
